<template>
  <div class="list-group">
    
    
    <vue-good-table
      :columns="tableColumns"
      :rows="sensorListFormatted"
      styleClass="vgt-table striped condensed"
      :search-options="{
        enabled: true}">
      <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <b-button @click="changeSelected(props.row)">Modifica</b-button>

          </span>
          <!--<span v-else-if="props.column.field == 'machineId'">
            {{getMachineLabel(props.row.machineId)}}
          </span>-->
          <span v-else-if="props.column.field == 'orderStatus'">
            {{getStatusLabel(props.row.orderStatus)}}
          </span>
        </template>
    </vue-good-table>
    {{ list }}
  </div>
</template>

<script>
export default {
  name: "SensorList",
  props: {
    list: { type: Array, default: () => [] },
    machineList: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectedSensor: null,
      tableColumns: [{
          label: '',
          field: 'actions',
        }, {
          label: 'Codice breve',
          field: 'dataCode',
        }, {
          label: 'Descrizione',
          field: 'description',
        }, {
        
          label: 'Campionamento(min)',
          field: 'sampling',
        }, {
        
        label: 'Registro',
        field: 'register',
        }/*, {
          label: 'Email',
          field: 'contact',
        }, {
        //  label: 'Data ordine',
        //  field: 'orderDate',
        },  {
          label: 'Note',
          field: 'notes',
        }*/
      ]
    }
  },
  mounted() {
    this.list.forEach( sensor => {
      sensor.machineName = this.getMachineLabel(sensor.machineId);
  
    });
  },
  computed: {
    sensorListFormatted(){
      return this.list.map( elem => {
        return {
          ...elem,
          machineName: this.getMachineLabel(elem.machineId)
        }
      })
    }

  },
  methods: {
    changeSelected(sensor) {
      //console.log('Sensor select: ',sensor);
      this.$emit("sensorChanged", sensor);
    },
    getMachineLabel(mId) {
      let machineName = this.machineList.find(m => m._id == mId);
      if(!machineName) machineName = 'Non trovata';
      else machineName = machineName.name + ' (' + machineName.shortCode + ')'; 
      //console.log(machineName);
      return machineName;
      
    },
    getStatusLabel(thisStatus){
      if(this.orderStatusList[thisStatus])
        return  this.orderStatusList[thisStatus];
      else 
        return 'Sconosciuto';
    }
  }
};
</script>